import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import makeStyles from "styles/muiStylesCompat/makeStyles";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

const useStyles = makeStyles((_theme) => ({
  paper: {
    flexGrow: 1,
    height: "100%",
    overflowX: "auto",
    padding: 48,
  },
}));

const Support = (_props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Fragment>
      <Paper className={classes.paper} elevation={0} square>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4">{t("Tuki")}</Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid size="grow">
            <Box sx={{ mb: 2 }}>
              <a href="https://opentaxi.fi/ohjeet" target="_blank">
                {t("Tutustu käyttöohjeisiin")}
              </a>
            </Box>
            <Box sx={{ mb: 4 }}>
              <a href="https://opentaxi.fi/faq" target="_blank">
                {t("Yleisiä kysymyksiä palvelun käytöstä")}
              </a>
            </Box>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2">
                {t("Ota yhteyttä tukeen")}
              </Typography>
              <a href="mailto:support@opentaxi.fi">support@opentaxi.fi</a>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Fragment>
  );
};

export default Support;
